// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__SgLkx","placeholdersHeader":"styles_placeholdersHeader__9dM0x","editorStyle":"styles_editorStyle__2aUpS","placeholdersBox":"styles_placeholdersBox__uaY4Y"};